/* eslint-disable import/prefer-default-export */
import { carryForwardModeOfColumns } from 'components/utils/carryForwardOnContinue';
import { getUsableCapacityInitialValue, itemValueOrEmpty } from '../utils/capacityFallback';
import { landCarriedValues } from '../utils/carryForward';
import { buildCustomOperatorFieldDefaults } from '../utils/customOperatorFieldDefaults';

export const getDefaultFormValues = (
  t,
  itemData,
  columnMappings,
  globalState,
  previousItemFormValues,
  fillingStatusFromValue,
  customOperatorFields = [],
  carryForwardModeOf = carryForwardModeOfColumns(columnMappings),
) => {
  const getCsv = (key) => columnMappings?.[key]?.mapping?.csvName;
  const getUnit = (key, fallback = '') => (columnMappings?.[key]?.mapping?.unit || fallback);

  const fillingCsv = getCsv('filling');
  const fillingStatus = fillingCsv ? fillingStatusFromValue(itemData[fillingCsv]) : 'full';
  const isEmpty = fillingStatus === 'empty';

  const liquidVolumeCsv = getCsv('liquidVolume');
  const emptyHeightCsv = getCsv('emptyHeight');
  const liquidHeightCsv = getCsv('liquidHeight');

  let measurementType = '';
  if (liquidVolumeCsv && itemData[liquidVolumeCsv] !== '') {
    measurementType = 'liquidVolume';
  } else if (emptyHeightCsv && itemData[emptyHeightCsv] !== '') {
    measurementType = 'emptyHeight';
  } else if (liquidHeightCsv) {
    measurementType = 'liquidHeight';
  }

  const totalCapacityCsv = getCsv('totalCapacity');
  const usableCapacityCsv = getCsv('usableCapacity');
  const totalCapacityUnit = getUnit('totalCapacity', 'L');
  const usableCapacityUnit = getUnit('usableCapacity', 'L');
  const heightUnderBungCsv = getCsv('heightUnderBung');

  const storedValues = {
    totalCapacity: {
      value: itemValueOrEmpty(itemData, totalCapacityCsv),
      unit: totalCapacityUnit,
    },
    usableCapacity: {
      value: getUsableCapacityInitialValue({
        itemData,
        fillingStatus,
        usableCapacityCsv,
        totalCapacityCsv,
        usableCapacityUnit,
        totalCapacityUnit,
      }),
      unit: usableCapacityUnit,
    },
    diameterBond: {
      value: itemValueOrEmpty(itemData, heightUnderBungCsv),
      unit: getUnit('heightUnderBung', 'cm'),
    },
    liquidHeight: {
      value: itemValueOrEmpty(itemData, liquidHeightCsv),
      unit: getUnit('heightUnderBung', 'cm'),
    },
    emptyHeight: {
      value: itemValueOrEmpty(itemData, emptyHeightCsv),
      unit: getUnit('heightUnderBung', 'cm'),
    },
    liquidVolume: {
      value: itemValueOrEmpty(itemData, liquidVolumeCsv),
      unit: getUnit('liquidVolume', 'L'),
    },
    measurementType,
    tav: { value: itemValueOrEmpty(itemData, getCsv('tav')), unit: globalState.userUnits.alcoholUnit },
    tavTemp: {
      value: itemValueOrEmpty(itemData, getCsv('tavTemperature')),
      unit: globalState.userUnits.temperatureUnit,
    },
    volumeTemp: {
      value: itemValueOrEmpty(itemData, getCsv('volumeTemperature')),
      unit: globalState.userUnits.temperatureUnit,
    },
    ...buildCustomOperatorFieldDefaults({
      itemData,
      columnMappings,
      customOperatorFields,
    }),
  };

  return landCarriedValues({
    storedValues,
    carriedValues: previousItemFormValues,
    carryForwardModeOf,
    customFields: customOperatorFields,
    carryMeasures: !isEmpty,
    isFull: fillingStatus === 'full',
  });
};
